import axios from "axios";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.log(error);
    // toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

function setAppAccess(token) {
  axios.defaults.headers.common["x-app-access"] = token;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setAppAccess,
};
